import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { analytics, analyticsService } from '@/lib/analytics/analytics.service'
import { router } from '@/lib/routing/router'

export default function App() {
  useEffect(() => {
    analyticsService.init()

    const handleError = (event: ErrorEvent) => {
      analytics.captureException(event.error ?? new Error(event.message), {
        source: 'window.onerror',
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      })
    }

    const handleRejection = (event: PromiseRejectionEvent) => {
      const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason))
      analytics.captureException(error, { source: 'unhandledrejection' })
    }

    window.addEventListener('error', handleError)
    window.addEventListener('unhandledrejection', handleRejection)

    return () => {
      window.removeEventListener('error', handleError)
      window.removeEventListener('unhandledrejection', handleRejection)
    }
  }, [])

  return <RouterProvider router={router} />
}
